
export const testRow: String = 'initial creation'; 

export const crmTitles: Array<String> = [
    "Mr",
    "Mrs",
    "Miss",
    "Dr",
    "Prof",
]

export const allowedKYCTypes = [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/pdf', // PDF files
    'application/pdf', // PDF files
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-powerpoint', // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'text/plain', // .txt
    'text/csv', // CSV files
    'application/rtf', // Rich Text Format
    'application/vnd.oasis.opendocument.text', // OpenDocument Text (.odt)
    'application/vnd.oasis.opendocument.spreadsheet', // OpenDocument Spreadsheet (.ods)
    'application/vnd.oasis.opendocument.presentation', // OpenDocument Presentation (.odp)
    'application/zip', // ZIP archives
    'application/x-7z-compressed', // 7z archives
    'application/x-rar-compressed', // RAR archives
];

export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
export const MAX_KYC_TOTAL_SIZE = 6 * 1024 * 1024;